import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import successIcon from "../../../../assets/icons/successIcon.svg";
import rejected from "../../../../assets/icons/rejected.svg";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import FilterSearch from "../../../../components/common/FilterSearch";
import { COMPLAINT_SEARCH_OPTIONS } from "../../utils/complaintFilter.config";
import { complaintFilterOptions } from "../../utils/complaintFilter.config";
import TableComplaintContent from "./TableComplaintContent";
import ImageSlider from "../../../../components/UI/viewDialogs/ImageSlider";
import ComplaintViewDialog from "../complaintDialog/ComplaintViewDialog";
import Dialog from "../../../../components/UI/Dialog";
import { formatComplaintExcelData } from "../../utils/excelFormatters";

const ComplaintPendingList = ({
  handleConfirmDialogBox,
  viewDialogDetails,
  setViewDialogDetails,
  confirmDialogBox,
  setConfirmDialogBox,
  isActionSucceed,
  setIsActionSucceed,
  buttonStatus,
  handleCheck,
  checkLoading,
  checkResponseData,
}) => {
  const [imageSliderPics, setImageSliderPics] = useState([]);
  const [imageSliderCurrentIndex, setImageSliderCurrentIndex] = useState();
  const copyData = useSelector((state) => state.data.copyData);
  const isCopyData = copyData.length > 0;

  // ...............get  excel data............
  const excelData = formatComplaintExcelData(copyData);
  const excelConfig = {
    data: excelData,
    fileName: "Pending_Complaints_Report",
    sheetName: "Pending Complaints",
  };

  const openViewDialog = (complaintsData) => {
    setViewDialogDetails({ open: true, data: complaintsData });
  };
  const closeViewDialog = () => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
  };

  const closeConfirmDialogBox = () => {
    setConfirmDialogBox(false);
    openViewDialog(viewDialogDetails.data);
  };

  const openImageSlider = (Pics) => {
    closeViewDialog();
    setImageSliderPics(Pics);
  };

  const closeImageSlider = () => {
    openViewDialog(viewDialogDetails.data);
    setImageSliderPics([]);
  };

  useEffect(() => {
    if (!isActionSucceed) return;

    const timeoutId = setTimeout(() => {
      setIsActionSucceed(false);
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isActionSucceed]);

  return (
    <>
      {/* page title container for mobile */}
      <MobileActionHeader title="Complaint Pending" />
      {/* data filter and data search container  */}
      {isCopyData ? (
        <FilterSearch
          categories={complaintFilterOptions}
          searchCategories={COMPLAINT_SEARCH_OPTIONS}
          isActionSucceed={isActionSucceed}
          checkResponseDataId={[checkResponseData.id]}
          excelConfig={excelConfig}
        />
      ) : (
        ""
      )}
      {/* all complaint pending table list */}
      <TableComplaintContent openViewDialog={openViewDialog} />
      {/* show complaint details view dialog */}
      {viewDialogDetails?.open && (
        <ComplaintViewDialog
          closeDialog={closeViewDialog}
          viewDetails={viewDialogDetails.data}
          openImageSlider={openImageSlider}
          setImageSliderCurrentIndex={setImageSliderCurrentIndex}
          accept={() => handleConfirmDialogBox(viewDialogDetails.data.id, true)}
          reject={() =>
            handleConfirmDialogBox(viewDialogDetails.data.id, false)
          }
          setComplaintViewDetails={setViewDialogDetails}
        />
      )}
      {/* show confirm dialog box to complaint checked */}
      {confirmDialogBox && (
        <Dialog
          message={
            buttonStatus
              ? "Are you sure you want to approve this complaint ?"
              : "Are you sure you want to Reject this complaint ?"
          }
          confirmBtnText={!checkLoading ? "Confirm" : "Loading..."}
          cancelBtnText="Cancel"
          closeDialog={closeConfirmDialogBox}
          checkAction={!checkLoading ? handleCheck : undefined}
        />
      )}
      {/* show success dialog box after complaint checked */}
      {isActionSucceed && (
        <Dialog
          message={
            buttonStatus
              ? "Complaint successfully approved!"
              : "Complaint successfully rejected!"
          }
          messageIcon={buttonStatus ? successIcon : rejected}
          closeDialog={() => setIsActionSucceed(false)}
        />
      )}
      {/* show view dialog images in image slider box */}
      {imageSliderPics.length !== 0 && (
        <ImageSlider
          title="Complaint Photos"
          images={imageSliderPics}
          imageSliderCurrentIndex={imageSliderCurrentIndex}
          closeDialogBox={closeImageSlider}
        />
      )}
    </>
  );
};

export default ComplaintPendingList;
